// eslint-disable react/prop-types
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import { useSpring, animated } from 'react-spring';
import IconButton from '@material-ui/core/IconButton';
import Octicon, { X } from '@primer/octicons-react';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    fontWeight: 'normal',
    textTransform: 'uppercase',
    fontSize: '1.2em'
  },
  title: {
    textAlign: 'center',
    display: 'flex',
    flexGrow: 1
  },
  button: {
    color: 'black'
  },
  innerTitle: {
    alignSelf: 'center'
  },
  width100: {
    width: '100%'
  },
  subtitle: {
    textAlign: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 2,
    outline: 0
  },
  document: {
    outline: 0,
    minWidth: '33%'
  }
});

const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

const NodeModalBare = ({ id, handleClose, open = true, classes }) => {
  return (
    <div>
      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open} className={classes.document}>
          <div className={classes.paper}>
            <Grid container className={classes.container}>
              <div className={classes.title}>
                <Grid container className={classes.innerTitle}>
                  <div className={classes.width100}>
                    Notes
                  </div>
                </Grid>
              </div>
              <IconButton
                color="primary"
                aria-label="directions"
                onClick={handleClose}
                className={classes.button}
              >
                <Octicon icon={X} verticalAlign='middle'/>
              </IconButton>
            </Grid>
            <p className={classes.subtitle}> bla bla </p>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}

export default withStyles(styles, { withTheme: true })(NodeModalBare);
